// extracted by mini-css-extract-plugin
module.exports = {"root":"Czu1XKvL","item":"rDJ5aew3"};